import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { app } from './config/app.js';
import { createTheme,ThemeProvider  } from '@mui/material/styles';
import { itIT as dataGriditIT } from '@mui/x-data-grid';
import { itIT as coreitIT } from '@mui/material/locale';
import { itIT } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import "dayjs/locale/it";
const defaultTheme = createTheme(app.theme,itIT,dataGriditIT,coreitIT);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <ThemeProvider theme={defaultTheme}>
    <LocalizationProvider  adapterLocale="it" dateAdapter={AdapterDayjs}>
    <App />
    </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
